<script lang="ts">
	import type { CompleteVariant, RequiredProduct } from '$lib/types';
	import { getTranslate } from '@tolgee/svelte';

	export let product: RequiredProduct;
	export let variant: CompleteVariant;

	$: bulletPoints = JSON.parse(variant.bulletPoints?.value ?? product.bulletPoints?.value ?? '{}');

	const { t } = getTranslate();
</script>

<ul class="mb-6">
	{#each Object.values(bulletPoints) as value}
		<li class="flex items-center justify-start py-1">
			<div class="i-sprenger-check flex-shrink-0 w-6 h-6" aria-hidden="true" />
			<p class="ml-2 text-p-12">{value}</p>
		</li>
	{/each}
	<li class="flex items-center justify-start py-1 mt-8">
		<div class="i-sprenger-check flex-shrink-0 w-6 h-6 opacity-0" aria-hidden="true" />
		<div class="ml-2">
			<p class="mb-1 text-p-12">{$t('product.productNumber')}</p>
			<span
				class="inline-flex items-center justify-center px-2 py-1 text-white rounded bg-dark-primary text-h-14"
			>
				{variant.sku?.value}
			</span>
		</div>
	</li>
</ul>
